import store from "../../store/store"
import { QueuesHub } from "../hubs/queues"

export const queuesHub = new QueuesHub(store)
